var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RatioBox',_vm._b({ref:"root",attrs:{"ratio":1}},'RatioBox',_vm.$attrs,false),[_c('Skeleton',{attrs:{"height":"100%","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }